import React from "react";
import MaPrimeAdapt from "./MaPrimeAdapt";

// Alias de /maprimeadapt conservé pour les liens existants. La page
// MaPrimeAdapt pose elle-même l'URL canonique vers /maprimeadapt : Google
// n'indexe donc qu'une seule version. Cette URL est retirée du sitemap.
const GuideMaPrimeAdapt = () => {
  return <MaPrimeAdapt />;
};

export default GuideMaPrimeAdapt;
